import { render, staticRenderFns } from "./CreatePurchasePoint.vue?vue&type=template&id=f9154c5a&scoped=true&"
import script from "./CreatePurchasePoint.vue?vue&type=script&lang=js&"
export * from "./CreatePurchasePoint.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchasePoint.vue?vue&type=style&index=0&id=f9154c5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9154c5a",
  null
  
)

export default component.exports